module.exports = __webpack_public_path__ + "static/media/picture-(131).00877a81.JPG";